import axios from "../axios";
import { BASE_URL, initApi } from "../initApi";

// ----------------------- APP - DIMENSION TABLE MAPPING
export async function dimensionTableMapping(productId) {
  return initApi().then(() => {
    return axios.get(`${BASE_URL}/api/dimension-table-mapping/${productId}`);
  });
}
